<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For My Father</i></p>
<p class="ded1"><i>John Wayne Collins</i></p>
<p class="ded1"><i>1933–2005</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e81f01fa